import React, { useState, useEffect } from 'react';
import './DeleteSlotModal.css';

const DeleteSlotModal = ({ open, onClose, slot, affectedBookings = [], onConfirm, isDeleting }) => {
  const [cancellationReason, setCancellationReason] = useState('');
  const [error, setError] = useState('');

  // Reset state when modal opens/closes
  useEffect(() => {
    if (open) {
      setCancellationReason('');
      setError('');
    }
  }, [open]);

  if (!open || !slot) return null;

  const handleConfirm = () => {
    if (!cancellationReason.trim()) {
      setError('Please provide a confirmation reason');
      return;
    }

    setError('');
    onConfirm(cancellationReason.trim());
  };

  const handleCancel = () => {
    setCancellationReason('');
    setError('');
    onClose();
  };

  const bookingCount = affectedBookings?.length || 0;

  return (
    <div className="delete-slot-modal-overlay" onClick={handleCancel}>
      <div className="delete-slot-modal" onClick={(e) => e.stopPropagation()}>
        <div className="delete-slot-modal-header">
          <h3>Delete Slot</h3>
          <button className="delete-slot-modal-close" onClick={handleCancel}>×</button>
        </div>

        <div className="delete-slot-modal-body">
          <div className="delete-slot-modal-warning">
            ⚠️ Warning: This action cannot be undone
          </div>

          <div className="delete-slot-modal-info">
            <div className="delete-slot-modal-info-label">Slot Time</div>
            <div className="delete-slot-modal-info-value">
              {slot.displayTime || `${slot.startTime} - ${slot.endTime}`}
            </div>
          </div>

          {slot.serviceName && (
            <div className="delete-slot-modal-info">
              <div className="delete-slot-modal-info-label">Service</div>
              <div className="delete-slot-modal-info-value">{slot.serviceName}</div>
            </div>
          )}

          <div className="delete-slot-modal-bookings">
            <div className="delete-slot-modal-bookings-header">
              {bookingCount === 0 ? 'No active bookings' : `${bookingCount} booking${bookingCount === 1 ? '' : 's'} will be cancelled`}
            </div>
            {bookingCount > 0 && (
              <div className="delete-slot-modal-bookings-list">
                {affectedBookings.map((booking, idx) => (
                  <div key={idx} className="delete-slot-modal-booking-item">
                    <div className="delete-slot-modal-booking-name">{booking.customerName}</div>
                    <div className="delete-slot-modal-booking-phone">{booking.customerPhone}</div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="delete-slot-modal-reason">
            <label htmlFor="deletion-confirmation-reason">
              Confirmation Reason
              <span className="required">*</span>
            </label>
            <textarea
              id="deletion-confirmation-reason"
              value={cancellationReason}
              onChange={(e) => {
                setCancellationReason(e.target.value);
                setError('');
              }}
              placeholder="E.g., Equipment failure, staff unavailable, emergency closure..."
              maxLength={500}
              rows={3}
              disabled={isDeleting}
            />
            <div className="delete-slot-modal-reason-hint">
              {cancellationReason.length}/500 characters
            </div>
            {error && <div className="delete-slot-modal-error">{error}</div>}
          </div>

          {bookingCount > 0 && (
            <div className="delete-slot-modal-notification-info">
              All affected customers will be notified via push notification
            </div>
          )}
        </div>

        <div className="delete-slot-modal-footer">
          <button
            className="delete-slot-modal-cancel-btn"
            onClick={handleCancel}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            className="delete-slot-modal-delete-btn"
            onClick={handleConfirm}
            disabled={isDeleting || !cancellationReason.trim()}
          >
            {isDeleting ? 'Deleting...' : 'Delete Slot'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteSlotModal;
